<script>
  import { auth_endpoint, client_id, redirect_uri } from './config.js';

</script>

<main>
<h1>Oh, no...</h1>
<p>
There was some kind of issue validating your session.
If you came directly to this link, try clicking on the link below to retry the authentication process.
If that doesn't work, try talking to someone in charge.
</p>

<a href={`${auth_endpoint}/oauth2/authorize?response_type=code&identity_provider=Okta&client_id=${client_id}&redirect_uri=${redirect_uri}&scope=email+openid`}>
Re-validate me!
</a>
</main>

<style>
  h1 {
    color: #ff6d5c;
    font-size: 48px;
    margin-top: 8px;
    margin-bottom: 5px;
  }
  main {
    padding: 16px;
    background-color: pink;
    width: 100vw;
    height: 100vh;
    margin: auto;
    box-sizing: border-box;
  }

  a {
    margin: auto;
  }
</style>
